import React from 'react';
import './EmailVerificationPage.scss';

const EmailVerificationPage: React.FC = () => (
  <div className="email-verify--page">
    <div className="email-verify--container">
      <div className="dev-portal-dashboard-title email-verify--title">Please check your email.</div>
      <div className="email-verify--description">
        Please verify the email address that you have provided in order for us to activate your
        account.
      </div>
    </div>
  </div>
);

export default EmailVerificationPage;
